
import { Component, Vue } from 'vue-property-decorator'

// 商品清单
@Component
export default class goodsListPopup extends Vue {
  store: any = {}
  show = false

  showPop (store: any) {
    this.store = store
    this.show = true
  }
}
